import { GQLResponseServerError } from '@change-corgi/core/gql';
import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import { LoginByEmail, type LoginByEmailMutation, type LoginByEmailMutationVariables } from './loginByEmail.graphql';

export type LoginByEmailMutationInput = LoginByEmailMutationVariables['input'];
export type LoginMutationResponse = LoginByEmailMutation['loginByEmail'];

export async function loginByEmail(
	input: LoginByEmailMutationInput,
	{ gql: { fetch } }: UtilityContext,
): Promise<LoginMutationResponse> {
	try {
		const { data } = await fetch<LoginByEmailMutation, LoginByEmailMutationVariables>({
			path: '/login',
			query: LoginByEmail,
			variables: {
				input,
			},
			rejectOnError: true,
			batched: false, // to ensure this rate limited mutation is not batched
		});
		if (!data) throw new Error('No data returned from query.');
		return data.loginByEmail;
	} catch (error) {
		if (error instanceof GQLResponseServerError) {
			if (error.status === 429) {
				return { status: 'RATE_LIMITED' };
			}
		}
		throw error;
	}
}
